import React from 'react';

export type PulseMarkMode = 'idle' | 'search' | 'refine';

export interface PulseIntelligenceMarkProps {
  size?: number;
  width?: number;
  height?: number;
  active?: boolean;
  mode?: PulseMarkMode;
  className?: string;
  title?: string;
}

/**
 * PulseIntelligenceMark / PulseSearchMark — Canonical Bloom mark for Universal AI & Search.
 * Renders the approved static transparent Bloom brand mark.
 */
export const PulseIntelligenceMark: React.FC<PulseIntelligenceMarkProps> = ({
  size = 20,
  width: customWidth,
  height: customHeight,
  className = '',
  title = 'Bloom'
}) => {
  const effectiveSize = customWidth || customHeight || size;

  return (
    <span title={title} className="inline-flex items-center justify-center shrink-0">
      <img
        src="/brand/canonical/bloom-mark-micro.svg"
        alt="Bloom"
        width={effectiveSize}
        height={effectiveSize}
        style={{ width: effectiveSize, height: effectiveSize }}
        className={`shrink-0 object-contain select-none ${className}`}
      />
    </span>
  );
};

/**
 * PulseSearchMark — Canonical alias for the Bloom search mark.
 */
export const PulseSearchMark = PulseIntelligenceMark;
